{
  "SEARCH": {
    "TABS": {
      "ALL": "所有結果",
      "CONTACTS": "聯絡人",
      "CONVERSATIONS": "對話",
      "MESSAGES": "訊息",
      "ARTICLES": "文章"
    },
    "SECTION": {
      "CONTACTS": "聯絡人",
      "CONVERSATIONS": "對話",
      "MESSAGES": "訊息",
      "ARTICLES": "文章"
    },
    "VIEW_MORE": "查看更多",
    "LOAD_MORE": "載入更多",
    "SEARCHING_DATA": "搜尋中",
    "LOADING_DATA": "載入中",
    "EMPTY_STATE": "找不到與「{query}」相符的{item}",
    "EMPTY_STATE_FULL": "找不到與「{query}」相符的結果",
    "PLACEHOLDER_KEYBINDING": "/ 聚焦搜尋",
    "INPUT_PLACEHOLDER": "輸入 3 個或更多字元以進行搜尋",
    "RECENT_SEARCHES": "最近搜尋",
    "CLEAR_ALL": "清除全部",
    "MOST_RECENT": "最新",
    "EMPTY_STATE_DEFAULT": "透過對話 ID、電子郵件、電話號碼、訊息進行搜尋，以獲得更佳的搜尋結果。",
    "BOT_LABEL": "機器人",
    "READ_MORE": "閱讀更多",
    "READ_LESS": "收合",
    "WROTE": "寫道：",
    "FROM": "來自",
    "EMAIL": "電子郵件",
    "EMAIL_SUBJECT": "主旨",
    "PRIVATE": "私人備註",
    "TRANSCRIPT": "對話紀錄",
    "CREATED_AT": "建立於 {time}",
    "UPDATED_AT": "更新於 {time}",
    "SORT_BY": {
      "RELEVANCE": "相關性"
    },
    "DATE_RANGE": {
      "LAST_7_DAYS": "最近 7 天",
      "LAST_30_DAYS": "最近 30 天",
      "LAST_60_DAYS": "最近 60 天",
      "LAST_90_DAYS": "最近 90 天",
      "CUSTOM_RANGE": "自訂範圍：",
      "CREATED_BETWEEN": "建立於",
      "AND": "至",
      "APPLY": "套用",
      "BEFORE_DATE": "{date} 之前",
      "AFTER_DATE": "{date} 之後",
      "TIME_RANGE": "依時間篩選",
      "CLEAR_FILTER": "清除篩選條件"
    },
    "FILTERS": {
      "FILTER_MESSAGE": "依以下條件篩選訊息：",
      "FROM": "發送者",
      "IN": "收件匣",
      "AGENTS": "客服人員",
      "CONTACTS": "聯絡人",
      "INBOXES": "收件匣",
      "NO_AGENTS": "找不到客服人員",
      "NO_CONTACTS": "開始搜尋以查看結果",
      "NO_INBOXES": "找不到收件匣"
    }
  }
}
